module.exports = __webpack_public_path__ + "static/card-badge-f2bae14b1df7d94725e2d7624addf0cc.svg";